import(/* webpackMode: "eager" */ "/codebuild/output/src2988847430/src/apps/raffle/src/app/error.tsx");
